<template>
  <div class="automation-payload">
    <div class="automation-actions">
      <strong>{{ label }}</strong>
      <AppButton design="new" theme="dark" size="small" :aria-expanded="String(open)" @click.native="open = !open"
        >{{ open ? 'Hide' : 'Show' }} {{ label }}</AppButton
      >
      <AppButton v-if="open && text !== null" design="new" theme="dark" size="small" @click.native="copy">{{
        copied ? 'Copied' : 'Copy'
      }}</AppButton>
    </div>
    <template v-if="open">
      <p v-if="!payload || payload.availability !== 'stored'" class="automation-muted">{{ unavailable }}</p>
      <template v-else
        ><p v-if="payload.reason" class="automation-muted">{{ payload.reason }}</p>
        <pre class="automation-pre" tabindex="0" :aria-label="label">{{ text }}</pre>
      </template>
      <p v-if="copyError" class="automation-problem" role="alert">{{ copyError }}</p>
    </template>
  </div>
</template>
<script>
import { payloadText } from './model'
export default {
  props: { payload: Object, label: { type: String, required: true } },
  data: () => ({ open: false, copied: false, copyError: '' }),
  computed: {
    text() {
      return payloadText(this.payload)
    },
    unavailable() {
      const label = this.payload && this.payload.availability === 'redacted' ? 'Redacted.' : 'Not recorded.'
      return `${label} ${(this.payload && this.payload.reason) || 'No saved payload is available.'}`
    }
  },
  methods: {
    async copy() {
      this.copyError = ''
      try {
        await navigator.clipboard.writeText(this.text)
        this.copied = true
      } catch (error) {
        this.copyError = 'Unable to copy. Select the text and copy it manually.'
      }
    }
  }
}
</script>
<style scoped lang="scss">
.automation-payload {
  margin-top: $ui-space-16;
}
pre {
  padding: $ui-space-16;
  background: $ui-surface-soft;
  border: 1px solid $ui-line;
  border-radius: $ui-panel-radius;
  margin-bottom: 0;
}
</style>
